const STORAGE_KEY = 'raheasy_ref';
const VISITOR_KEY = 'raheasy_vid';
const CLICK_SENT_PREFIX = 'raheasy_ref_click_';

function getApiBase() {
  return (process.env.REACT_APP_API_URL || '').replace(/\/+$/, '');
}

export function getOrCreateVisitorId() {
  try {
    let vid = localStorage.getItem(VISITOR_KEY);
    if (!vid) {
      vid = `v_${Math.random().toString(36).slice(2)}_${Date.now().toString(36)}`;
      localStorage.setItem(VISITOR_KEY, vid);
    }
    return vid;
  } catch {
    return null;
  }
}

export function getStoredReferralCode() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed?.code) return null;
    const maxAgeMs = (Number(process.env.REACT_APP_REFERRAL_ATTRIBUTION_DAYS) || 30) * 86400000;
    if (parsed.at && Date.now() - parsed.at > maxAgeMs) {
      localStorage.removeItem(STORAGE_KEY);
      return null;
    }
    return parsed.code;
  } catch {
    return null;
  }
}

export function storeReferralCode(code) {
  const normalized = String(code || '').trim().toUpperCase();
  if (!normalized) return;
  try {
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ code: normalized, at: Date.now() })
    );
  } catch {
    // ignore storage failures
  }
}

export async function trackReferralClick({ code, sessionId, landingPath }) {
  const normalized = String(code || '').trim().toUpperCase();
  if (!normalized) return;

  const clickKey = `${CLICK_SENT_PREFIX}${normalized}`;
  try {
    if (sessionStorage.getItem(clickKey)) return;
    sessionStorage.setItem(clickKey, '1');
  } catch {
    // continue even if sessionStorage unavailable
  }

  const apiBase = getApiBase();
  if (!apiBase) return;

  const visitorId = getOrCreateVisitorId();

  try {
    await fetch(`${apiBase}/api/referral/track`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        code: normalized,
        sessionId: sessionId || null,
        visitorId,
        landingPath: landingPath || window.location.pathname,
        eventType: 'click',
      }),
      keepalive: true,
    });
  } catch (error) {
    console.warn('Referral click tracking failed:', error);
  }
}

export function captureReferralFromUrl(searchParams, sessionId) {
  const ref = searchParams?.get('ref') || searchParams?.get('referral');
  if (!ref) return null;

  storeReferralCode(ref);
  trackReferralClick({
    code: ref,
    sessionId,
    landingPath: `${window.location.pathname}${window.location.search}`,
  });
  return ref;
}

export function getReferralSignupPayload(sessionId) {
  const code = getStoredReferralCode();
  if (!code) return {};
  return {
    referralCode: code,
    sessionId: sessionId || null,
    visitorId: getOrCreateVisitorId(),
  };
}
